<script setup lang="ts">
import { computed } from 'vue'
import { useEngraverStore } from '@/stores/engraver'

// Persistent active-device selector. Hidden when a tenant owns 0 or 1 engraver,
// so single-device customers see no new chrome. Selection is sticky per user
// (writes the user default via the store).
const engraverStore = useEngraverStore()

const show = computed(() => engraverStore.engravers.length > 1)
const selectedId = computed(() => engraverStore.selectedEngraver?.engraver_id ?? '')

function onChange(e: Event) {
  const id = (e.target as HTMLSelectElement).value
  if (id) engraverStore.setSelectedEngraver(id)
}
</script>

<template>
  <div v-if="show" class="relative flex items-center">
    <span
      class="w-2 h-2 rounded-full mr-2"
      :class="engraverStore.selectedEngraver && engraverStore.selectedEngraver.status !== 'offline'
        ? 'bg-green-500' : 'bg-red-500'"
    ></span>
    <select
      :value="selectedId"
      @change="onChange"
      class="text-sm text-gray-700 bg-white border border-gray-300 rounded-md pl-2 pr-7 py-1.5
             hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300
             max-w-[7.5rem] sm:max-w-[10rem] truncate"
      title="Active engraver"
    >
      <option v-for="e in engraverStore.engravers" :key="e.engraver_id" :value="e.engraver_id">
        {{ e.name }}{{ e.status === 'offline' ? ' (offline)' : '' }}
      </option>
    </select>
  </div>
</template>
